import { Alert, Button, Stack, Typography } from '@mui/material';
import { useAuth } from 'react-oidc-context';
import { useTranslation } from 'react-i18next';

// components
import 'components/LoginPage/loginPage.scss';
import TermsModalDisplay from 'components/LoginPage/TermsModalDisplay/TermsModalDisplay';
// assets
import logosLogin from 'assets/png/eco-gagnant-login.png';
import logosPartners from 'assets/png/ensemble-partenaires.png';
import logosFunders from 'assets/png/ensemble-financeurs.png';
import logosTurfs from 'assets/png/logo-territoires-white.png';
import logoInPhone from 'assets/png/eco-gagnant-smartphone.png';

interface Props {
  redirectUri: string | undefined;
}

export const LoginPage = ({ redirectUri }: Props) => {
  const auth = useAuth();
  const { t } = useTranslation();
  const redirect = redirectUri ? { redirect_uri: redirectUri } : undefined;

  return (
    <div id="login-page">
      <TermsModalDisplay />

      <div id="form-section">
        <img
          style={{ display: 'none' }}
          src={logoInPhone}
          alt="logo dans un smartphone - caché"
        />

        <div id="eco-gagnant-logo-wrapper">
          <img src={logosLogin} alt="logos eco-gagnant login" />
        </div>

        <Stack spacing={2}>
          <Typography id="catch-phrase" alignSelf="center">
            {t('loginPage.catchPhrase')}
          </Typography>

          <Button
            variant="contained"
            size="large"
            onClick={() => void auth.signinRedirect(redirect)}
            disabled={auth.isLoading}
          >
            {t('loginPage.login')}
          </Button>

          {redirectUri && (
            <Typography variant="subtitle1">
              {redirectUri.includes('?cbFrom=')
                ? t('konnector_modal.success_cb_redirect')
                : t('loginPage.forRedirection')}
            </Typography>
          )}

          {auth.error && <Alert severity="error">{auth.error.message}</Alert>}
        </Stack>
      </div>

      <div id="logos-section-bottom">
        <div id="turfs-wrapper">
          <span>{t('loginPage.withSupportOf')}</span>
          <div id="turfs-logos">
            <img src={logosTurfs} alt="banque des territoires" />
          </div>
        </div>

        <div id="funders-logos">
          <img src={logosFunders} alt="ensemble de logos financeurs" />
        </div>

        <div id="partners-logos">
          <img src={logosPartners} alt="ensemble de logos partenaires" />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
